var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "locations-thin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996,1.9998c-4.199,0-8,3.22-8,8.2c0,3.179,2.448,6.917,7.336,11.224 c0.375,0.33,0.954,0.33,1.329,0c4.888-4.307,7.335-8.045,7.335-11.224C19.9996,5.2198,16.1996,1.9998,11.9996,1.9998  M11.9996,20.0078c-4.314-3.864-6.5-7.161-6.5-9.808c0-4.352,3.349-6.7,6.5-6.7s6.5,2.348,6.5,6.7 C18.4996,12.8468,16.3136,16.1438,11.9996,20.0078 M15.5717,8.5808L13.311,8.3865l-0.8824-2.0802 c-0.1612-0.3795-0.6995-0.3795-0.8606,0l-0.8824,2.0836l-2.2573,0.192C8.0169,8.6173,7.8489,9.1305,8.162,9.4014l1.7144,1.4858 l-0.5155,2.207c-0.0937,0.4023,0.3429,0.7201,0.6972,0.5063l1.9396-1.1715l1.9419,1.1727c0.3543,0.2137,0.7909-0.104,0.6983-0.5063 l-0.5132-2.2082l1.7133-1.4881C16.1501,9.1282,15.9832,8.6162,15.5717,8.5808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.599f7dcd.svg";
export { ForwardRef as ReactComponent };